import { useState, useCallback } from "react";
import * as api from "../api";

// Cuadrante de guardias: una fila por semana, identificada por su lunes.
// Solo un admin puede escribir; el backend rechaza al resto con 403.
export function useGuardias(token, showToast) {
  const [guardias, setGuardias] = useState([]);

  const loadGuardias = useCallback(async (from, to) => {
    if (!token) return;
    try {
      const data = await api.getGuardias(from, to);
      if (Array.isArray(data)) setGuardias(data);
    } catch (e) {
      showToast("Error al cargar las guardias", "error");
    }
  }, [token]); // eslint-disable-line

  // Asignar una semana. Sin userId se desasigna y la fila desaparece.
  const setGuardia = async (semana, userId) => {
    try {
      const g = await api.setGuardia(semana, userId || null);
      // El backend avisa si esa persona esta de vacaciones esa semana
      if (g?.aviso) showToast(g.aviso, "warn");
      setGuardias(p => {
        const resto = p.filter(x => x.semana_inicio !== semana);
        return userId ? [...resto, g].sort((a,b)=>a.semana_inicio.localeCompare(b.semana_inicio)) : resto;
      });
    } catch (e) { showToast(e.message || "Error al asignar la guardia", "error"); }
  };

  // Tras un reparto masivo se recarga: el backend continúa la rotación desde la
  // última semana ya asignada, así que el resultado no es deducible en cliente.
  // El plan llega ya calculado desde la vista; aqui solo se persiste y se avisa
  const aplicarPlan = async (plan, from, to) => {
    if (!plan?.asignaciones?.length) { showToast("No hay semanas que repartir", "warn"); return; }
    try {
      const r = await api.asignarLoteGuardias(plan.asignaciones);
      await loadGuardias(from, to);
      const partes = [`${r.guardadas} semana(s) repartida(s)`];
      if (plan.respetadas) partes.push(`${plan.respetadas} sin tocar`);
      if (plan.sinCubrir)  partes.push(`${plan.sinCubrir} sin nadie libre`);
      showToast(partes.join(" · "), plan.sinCubrir ? "warn" : "ok");
      return r;
    } catch (e) { showToast(e.message || "Error al guardar el cuadrante", "error"); }
  };

  const limpiar = async (desde, hasta) => {
    try {
      const r = await api.limpiarGuardias(desde, hasta);
      setGuardias(p => p.filter(x => x.semana_inicio < desde || x.semana_inicio > hasta));
      showToast(`${r.borradas} semana(s) vaciada(s)`, "warn");
      return r;
    } catch (e) { showToast(e.message || "Error al vaciar el cuadrante", "error"); }
  };

  const importar = async (text, mapa, comprobar) => {
    try {
      const r = await api.importarGuardias(text, mapa, comprobar);
      if (!comprobar && !r.comprobado) {
        await loadGuardias();
        showToast(`${r.importadas} semana(s) importada(s)`);
      }
      return r;
    } catch (e) { showToast(e.message || "Error al importar el cuadrante", "error"); return null; }
  };

  return { guardias, setGuardias, loadGuardias, setGuardia, aplicarPlan, limpiar, importar };
}
